import type { OnDestroy } from '@angular/core';
import { Component, inject, NgZone } from '@angular/core';
import { eventInfo } from '../../../app.constants';

@Component({
  selector: 'app-coming-soon',
  imports: [],
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.scss',
})
export class ComingSoonComponent implements OnDestroy {
  protected readonly comingSoonDateTime = new Date(eventInfo()['dateTime']);
  protected days = 0;
  protected hours = 0;
  protected minutes = 0;
  protected seconds = 0;
  #intervalId: any | null = null;
  readonly #ngZone = inject(NgZone);

  constructor() {
    this.#updateCountdown();

    if (this.#getRemainingTime() > 0) {
      this.#ngZone.runOutsideAngular(() => {
        this.#intervalId = setInterval(() => {
          this.#ngZone.run(() => this.#updateCountdown());
        }, 1000);
      });
    }
  }

  #updateCountdown(): void {
    const remainingTime = this.#getRemainingTime();
    if (remainingTime < 0) {
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
      return;
    }
    this.days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    this.hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
    this.minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
    this.seconds = Math.floor((remainingTime / 1000) % 60);
  }

  #getRemainingTime(): number {
    const now = new Date();
    return this.comingSoonDateTime.getTime() - now.getTime();
  }

  ngOnDestroy(): void {
    if (this.#intervalId !== null) {
      clearInterval(this.#intervalId);
    }
  }
}
